import { PropsWithChildren } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Button } from "@mui/material";

import { CabinsColors } from "@/constants/config";
import useThemeData from "@/hooks/useThemeData";

const SortButton = (
  props: PropsWithChildren<{ color: string; value: string; onChange: (v: string) => void }>
) => {
  const { onChange, value, color } = props;

  return (
    <Button
      variant="contained"
      className="flex-1 relative"
      sx={{
        borderRadius: 0,
        backgroundColor: color,
        fontWeight: 600,
        color: "white",
        ".MuiChip-icon": {
          color: "white",
        },
      }}
      onClick={() => {
        if (!value) {
          onChange("desc");
        }

        if (value === "desc") {
          onChange("asc");
        }

        if (value === "asc") {
          onChange("");
        }
      }}
    >
      <span>{props.children}</span>
      <span className="absolute right-[4px] flex flex-col">
        {!props.value && (
          <>
            <ArrowDropUpIcon sx={{ fontSize: 16 }} className="relative bottom-[-4px]" />
            <ArrowDropDownIcon sx={{ fontSize: 16 }} className="relative top-[-4px]" />
          </>
        )}
        {props.value == "desc" && <ArrowDropUpIcon sx={{ fontSize: 16 }} />}
        {props.value == "asc" && <ArrowDropDownIcon sx={{ fontSize: 16 }} />}
      </span>
    </Button>
  );
};

const CabinSort = (props: { value: number; onChange: (v: number) => void }) => {
  const { value, onChange } = props;

  const economyValue = value === 6 ? "desc" : value === 62 ? "asc" : "";
  const premiumEconomyValue = value === 7 ? "desc" : value === 64 ? "asc" : "";
  const businessValue = value === 8 ? "desc" : value === 66 ? "asc" : "";
  const firstValue = value === 9 ? "desc" : value === 68 ? "asc" : "";

  const { isDarkMode } = useThemeData();

  return (
    <div className="flex sticky top-0 z-[2] mb-2">
      <div className="flex items-center flex-1">
        <div className="w-[40%]" />

        <div className="flex-1 flex space-x-[1px] ml-[1px]">
          <div
            className="w-[124px] text-center"
            style={{
              backgroundColor: isDarkMode ? "#272727" : "white",
            }}
          >
            <Button
              sx={{
                width: "100%",
                borderRadius: 0,
                fontWeight: 600,
              }}
            >
              transfer
            </Button>
          </div>
          <SortButton
            color={CabinsColors.economy}
            value={economyValue}
            onChange={(v) => {
              if (v === "desc") {
                onChange(6);
                return;
              }

              if (v === "asc") {
                onChange(62);
                return;
              }

              onChange(1);
            }}
          >
            Economy
          </SortButton>

          <SortButton
            value={premiumEconomyValue}
            color={CabinsColors.premiumEconomy}
            onChange={(v) => {
              if (v === "desc") {
                onChange(7);
                return;
              }

              if (v === "asc") {
                onChange(64);
                return;
              }

              onChange(1);
            }}
          >
            Premium Eco
          </SortButton>

          <SortButton
            color={CabinsColors.business}
            value={businessValue}
            onChange={(v) => {
              if (v === "desc") {
                onChange(8);
                return;
              }

              if (v === "asc") {
                onChange(66);
                return;
              }

              onChange(1);
            }}
          >
            Business
          </SortButton>

          <SortButton
            color={CabinsColors.first}
            value={firstValue}
            onChange={(v) => {
              if (v === "desc") {
                onChange(9);
                return;
              }

              if (v === "asc") {
                onChange(68);
                return;
              }

              onChange(1);
            }}
          >
            First
          </SortButton>
        </div>
        {/* <div className="w-[4px]" /> */}
      </div>
      <div className="w-[40px]" />
    </div>
  );
};
export default CabinSort;
